import { gsap, ScrollTrigger } from "./globals.js";
import { isLargeNonTouchDevice } from './globals.js';

document.addEventListener("DOMContentLoaded", () => {
	// HERO
	const heroImage = document.querySelector('.hero__featured__img');
	if (heroImage) {
	  gsap.to('.hero__featured__img', {
		  scale: 1,
		  borderRadius: 0,
		  ease: 'none',
		  scrollTrigger: {
		    trigger: '.hero',
		    start: 'top top',
		    end: 'bottom 80%',
		    scrub: 1,
		  }
	  });

	  if (isLargeNonTouchDevice()) {
		  const image = document.querySelector('.hero__featured__img img');
			if (image) {
			  gsap.fromTo(image, {
			    y: '-20%',
			  }, {
			    y: '0%',
			    ease: 'none',
			    scrollTrigger: {
			      trigger: '.hero',
			      start: 'top top',
		      	  end: 'bottom bottom',
			      scrub: true,
			    }
			  });
			}
		}
	}

	const heroClipImage = document.querySelector('.hero__clip-img');
	if (heroClipImage) {
	  gsap.to('.hero__clip-img', {
		  scale: 1,
		  opacity: 1,
		  ease: 'power2.out',
		  duration: 2,
	  });
	}
});
